export const AQL_TYPE = [
  {label: 'Default', value: 'default'},
  {label: 'Measurement', value: 'measurement'},
]
export const AQL_TYPE_VALUE = {
  DEFAULT: 'default',
  MEASUREMENT: 'measurement',
} as const 
export const INSPECTON_LEVEL = [
  {
    label: 'NO AQL',
    value: 'NO AQL',
  },
  {
    label: 'I',
    value: 'I',
  },
  {
    label: 'II',
    value: 'II',
  },
  {
    label: 'III',
    value: 'III',
  },
  {
    label: 'S1',
    value: 'S1',
  },
  {
    label: 'S2',
    value: 'S2',
  },
  {
    label: 'S3',
    value: 'S3',
  },
  {
    label: 'S4',
    value: 'S4',
  },
]

export const AQL_LEVEL = [
  {
    label: 'NO AQL',
    value: 'NO AQL',
  },
  {
    label: 'NOT ALLOWED',
    value: 'NOT ALLOWED',
  },
  {
    label: '0.065',
    value: '0.065',
  },
  {
    label: '0.10',
    value: '0.10',
  },
  {
    label: '0.15',
    value: '0.15',
  },
  {
    label: '0.25',
    value: '0.25',
  },
  {
    label: '0.40',
    value: '0.40',
  },
  {
    label: '0.65',
    value: '0.65',
  },
  {
    label: '1.0',
    value: '1.0',
  },
  {
    label: '1.5',
    value: '1.5',
  },
  {
    label: '2.5',
    value: '2.5',
  },
  {
    label: '4.0',
    value: '4.0',
  },
  {
    label: '6.5',
    value: '6.5',
  },
  {
    label: '10',
    value: '10',
  },
  {
    label: '15',
    value: '15',
  },
  {
    label: '25',
    value: '25',
  },
  {
    label: '40',
    value: '40',
  },
  {
    label: '65',
    value: '65',
  },
  {
    label: '100',
    value: '100',
  },
  {
    label: '150',
    value: '150',
  },
  {
    label: '250',
    value: '250',
  },
  {
    label: '400',
    value: '400',
  },
  {
    label: '650',
    value: '650',
  },
  {
    label: '1000',
    value: '1000',
  },
  {
    label: 'Tighten 2.5',
    value: 'Tighten 2.5',
  },
]

export const SAMPLE_SIZES = [
  {
    label: '2',
    value: '2',
  },
  {
    label: '3',
    value: '3',
  },
  {
    label: '5',
    value: '5',
  },
  {
    label: '8',
    value: '8',
  },
  {
    label: '13',
    value: '13',
  },
  {
    label: '20',
    value: '20',
  },
  {
    label: '32',
    value: '32',
  },
  {
    label: '50',
    value: '50',
  },
  {
    label: '80',
    value: '80',
  },
  {
    label: '125',
    value: '125',
  },
  {
    label: '200',
    value: '200',
  },
  {
    label: '315',
    value: '315',
  },
  {
    label: '500',
    value: '500',
  },
  {
    label: '800',
    value: '800',
  },
  {
    label: '1250',
    value: '1250',
  },
  {
    label: '2000',
    value: '2000',
  },
]

export const aql_sample_size_code = [
  {
    lotSizeFromRank: 10001,
    sampleSize: '315',
    lotSizeToRank: 35000,
    code: 'M',
    level: 'II',
  },
  {
    code: 'K',
    lotSizeToRank: 35000,
    level: 'I',
    sampleSize: '125',
    lotSizeFromRank: 10001,
  },
  {
    code: 'A',
    lotSizeFromRank: 2,
    sampleSize: '2',
    level: 'S2',
    lotSizeToRank: 8,
  },
  {
    level: 'II',
    sampleSize: '125',
    code: 'K',
    lotSizeToRank: 3200,
    lotSizeFromRank: 1201,
  },
  {
    lotSizeToRank: 90,
    lotSizeFromRank: 51,
    code: 'C',
    sampleSize: '5',
    level: 'S3',
  },
  {
    lotSizeFromRank: 2,
    sampleSize: '2',
    lotSizeToRank: 8,
    level: 'II',
    code: 'A',
  },
  {
    code: 'A',
    sampleSize: '2',
    level: 'S4',
    lotSizeToRank: 15,
    lotSizeFromRank: 9,
  },
  {
    code: 'A',
    lotSizeFromRank: 2,
    lotSizeToRank: 8,
    sampleSize: '2',
    level: 'S3',
  },
  {
    lotSizeToRank: 25,
    lotSizeFromRank: 16,
    sampleSize: '3',
    level: 'S4',
    code: 'B',
  },
  {
    lotSizeFromRank: 16,
    lotSizeToRank: 25,
    code: 'D',
    level: 'III',
    sampleSize: '8',
  },
  {
    sampleSize: '5',
    level: 'S4',
    code: 'C',
    lotSizeFromRank: 26,
    lotSizeToRank: 50,
  },
  {
    code: 'G',
    lotSizeFromRank: 150001,
    sampleSize: '32',
    lotSizeToRank: 500000,
    level: 'S3',
  },
  {
    lotSizeToRank: 150,
    sampleSize: '3',
    level: 'S1',
    lotSizeFromRank: 91,
    code: 'B',
  },
  {
    lotSizeFromRank: 1201,
    lotSizeToRank: 3200,
    sampleSize: '50',
    level: 'I',
    code: 'H',
  },
  {
    sampleSize: '2',
    level: 'S1',
    lotSizeFromRank: 26,
    lotSizeToRank: 50,
    code: 'A',
  },
  {
    lotSizeFromRank: 281,
    lotSizeToRank: 500,
    level: 'S4',
    code: 'E',
    sampleSize: '13',
  },
  {
    code: 'B',
    lotSizeToRank: 90,
    level: 'S2',
    sampleSize: '3',
    lotSizeFromRank: 51,
  },
  {
    lotSizeToRank: 1200,
    lotSizeFromRank: 501,
    sampleSize: '5',
    level: 'S1',
    code: 'C',
  },
  {
    code: 'M',
    lotSizeToRank: 500000,
    sampleSize: '315',
    lotSizeFromRank: 150001,
    level: 'I',
  },
  {
    code: 'G',
    lotSizeToRank: 150000,
    level: 'S3',
    sampleSize: '32',
    lotSizeFromRank: 35001,
  },
  {
    lotSizeToRank: 280,
    level: 'II',
    code: 'G',
    sampleSize: '32',
    lotSizeFromRank: 151,
  },
  {
    lotSizeToRank: 15,
    level: 'S1',
    code: 'A',
    sampleSize: '2',
    lotSizeFromRank: 9,
  },
  {
    lotSizeToRank: 1200,
    code: 'E',
    level: 'S3',
    sampleSize: '13',
    lotSizeFromRank: 501,
  },
  {
    lotSizeToRank: 280,
    level: 'S4',
    code: 'E',
    sampleSize: '13',
    lotSizeFromRank: 151,
  },
  {
    lotSizeToRank: 8,
    level: 'III',
    code: 'B',
    lotSizeFromRank: 2,
    sampleSize: '3',
  },
  {
    sampleSize: '13',
    level: 'III',
    lotSizeToRank: 50,
    code: 'E',
    lotSizeFromRank: 26,
  },
  {
    code: 'C',
    lotSizeFromRank: 3201,
    sampleSize: '5',
    lotSizeToRank: 10000,
    level: 'S1',
  },
  {
    level: 'I',
    sampleSize: '200',
    lotSizeFromRank: 35001,
    lotSizeToRank: 150000,
    code: 'L',
  },
  {
    lotSizeFromRank: 500001,
    lotSizeToRank: 0,
    code: 'R',
    sampleSize: '2000',
    level: 'III',
  },
  {
    level: 'III',
    code: 'J',
    lotSizeToRank: 500,
    sampleSize: '80',
    lotSizeFromRank: 281,
  },
  {
    sampleSize: '50',
    lotSizeToRank: 35000,
    level: 'S4',
    code: 'H',
    lotSizeFromRank: 10001,
  },
  {
    sampleSize: '8',
    lotSizeToRank: 50,
    lotSizeFromRank: 26,
    level: 'II',
    code: 'D',
  },
  {
    level: 'I',
    sampleSize: '32',
    lotSizeToRank: 1200,
    code: 'G',
    lotSizeFromRank: 501,
  },
  {
    lotSizeToRank: 3200,
    level: 'S2',
    sampleSize: '8',
    code: 'D',
    lotSizeFromRank: 1201,
  },
  {
    lotSizeToRank: 150000,
    lotSizeFromRank: 35001,
    code: 'N',
    sampleSize: '500',
    level: 'II',
  },
  {
    level: 'S3',
    sampleSize: '20',
    lotSizeToRank: 35000,
    code: 'F',
    lotSizeFromRank: 10001,
  },
  {
    code: 'E',
    lotSizeFromRank: 51,
    level: 'II',
    sampleSize: '13',
    lotSizeToRank: 90,
  },
  {
    code: 'D',
    level: 'S1',
    lotSizeToRank: 150000,
    sampleSize: '8',
    lotSizeFromRank: 35001,
  },
  {
    lotSizeToRank: 150,
    lotSizeFromRank: 91,
    sampleSize: '8',
    level: 'I',
    code: 'D',
  },
  {
    lotSizeToRank: 90,
    level: 'S1',
    sampleSize: '3',
    code: 'B',
    lotSizeFromRank: 51,
  },
  {
    lotSizeFromRank: 26,
    level: 'I',
    sampleSize: '5',
    lotSizeToRank: 50,
    code: 'C',
  },
  {
    sampleSize: '1250',
    lotSizeToRank: 0,
    level: 'II',
    code: 'Q',
    lotSizeFromRank: 500001,
  },
  {
    sampleSize: '80',
    level: 'S4',
    lotSizeToRank: 150000,
    lotSizeFromRank: 35001,
    code: 'J',
  },
  {
    lotSizeToRank: 1200,
    lotSizeFromRank: 501,
    sampleSize: '20',
    code: 'F',
    level: 'S4',
  },
  {
    lotSizeFromRank: 91,
    code: 'D',
    sampleSize: '8',
    lotSizeToRank: 150,
    level: 'S4',
  },
  {
    sampleSize: '125',
    level: 'III',
    lotSizeFromRank: 501,
    lotSizeToRank: 1200,
    code: 'K',
  },
  {
    lotSizeFromRank: 9,
    sampleSize: '2',
    code: 'A',
    lotSizeToRank: 15,
    level: 'S3',
  },
  {
    sampleSize: '50',
    level: 'III',
    lotSizeFromRank: 151,
    lotSizeToRank: 280,
    code: 'H',
  },
  {
    sampleSize: '500',
    level: 'I',
    lotSizeToRank: 0,
    lotSizeFromRank: 500001,
    code: 'N',
  },
  {
    sampleSize: '80',
    lotSizeToRank: 500000,
    level: 'S4',
    code: 'J',
    lotSizeFromRank: 150001,
  },
  {
    lotSizeFromRank: 2,
    level: 'S1',
    code: 'A',
    sampleSize: '2',
    lotSizeToRank: 8,
  },
  {
    sampleSize: '8',
    lotSizeFromRank: 10001,
    lotSizeToRank: 35000,
    level: 'S2',
    code: 'D',
  },
  {
    sampleSize: '8',
    lotSizeToRank: 280,
    level: 'S3',
    code: 'D',
    lotSizeFromRank: 151,
  },
  {
    lotSizeFromRank: 9,
    level: 'III',
    sampleSize: '5',
    lotSizeToRank: 15,
    code: 'C',
  },
  {
    level: 'S3',
    code: 'E',
    sampleSize: '13',
    lotSizeToRank: 3200,
    lotSizeFromRank: 1201,
  },
  {
    level: 'S2',
    lotSizeFromRank: 150001,
    lotSizeToRank: 500000,
    sampleSize: '13',
    code: 'E',
  },
  {
    lotSizeToRank: 25,
    level: 'II',
    sampleSize: '5',
    code: 'C',
    lotSizeFromRank: 16,
  },
  {
    level: 'S4',
    sampleSize: '2',
    lotSizeToRank: 8,
    lotSizeFromRank: 2,
    code: 'A',
  },
  {
    code: 'B',
    sampleSize: '3',
    level: 'S1',
    lotSizeToRank: 280,
    lotSizeFromRank: 151,
  },
  {
    lotSizeToRank: 90,
    level: 'III',
    code: 'F',
    lotSizeFromRank: 51,
    sampleSize: '20',
  },
  {
    code: 'D',
    lotSizeFromRank: 3201,
    sampleSize: '8',
    lotSizeToRank: 10000,
    level: 'S2',
  },
  {
    lotSizeToRank: 35000,
    code: 'N',
    lotSizeFromRank: 10001,
    level: 'III',
    sampleSize: '500',
  },
  {
    level: 'S1',
    lotSizeToRank: 25,
    sampleSize: '2',
    code: 'A',
    lotSizeFromRank: 16,
  },
  {
    level: 'S4',
    code: 'G',
    lotSizeToRank: 10000,
    sampleSize: '32',
    lotSizeFromRank: 3201,
  },
  {
    level: 'III',
    sampleSize: '800',
    lotSizeFromRank: 35001,
    code: 'P',
    lotSizeToRank: 150000,
  },
  {
    sampleSize: '3',
    level: 'S2',
    code: 'B',
    lotSizeFromRank: 91,
    lotSizeToRank: 150,
  },
  {
    code: 'B',
    level: 'S3',
    sampleSize: '3',
    lotSizeFromRank: 26,
    lotSizeToRank: 50,
  },
  {
    lotSizeToRank: 1200,
    sampleSize: '5',
    level: 'S2',
    lotSizeFromRank: 501,
    code: 'C',
  },
  {
    sampleSize: '1250',
    lotSizeToRank: 500000,
    level: 'III',
    lotSizeFromRank: 150001,
    code: 'Q',
  },
  {
    code: 'F',
    lotSizeToRank: 10000,
    level: 'S3',
    lotSizeFromRank: 3201,
    sampleSize: '20',
  },
  {
    level: 'S4',
    lotSizeFromRank: 500001,
    lotSizeToRank: 0,
    code: 'K',
    sampleSize: '125',
  },
  {
    level: 'S3',
    sampleSize: '8',
    code: 'D',
    lotSizeToRank: 500,
    lotSizeFromRank: 281,
  },
  {
    code: 'H',
    lotSizeFromRank: 281,
    level: 'II',
    lotSizeToRank: 500,
    sampleSize: '50',
  },
  {
    code: 'P',
    sampleSize: '800',
    lotSizeToRank: 500000,
    level: 'II',
    lotSizeFromRank: 150001,
  },
  {
    lotSizeToRank: 8,
    sampleSize: '2',
    lotSizeFromRank: 2,
    code: 'A',
    level: 'I',
  },
  {
    sampleSize: '8',
    code: 'D',
    level: 'S1',
    lotSizeFromRank: 150001,
    lotSizeToRank: 500000,
  },
  {
    code: 'C',
    sampleSize: '5',
    lotSizeToRank: 150,
    level: 'S3',
    lotSizeFromRank: 91,
  },
  {
    code: 'E',
    lotSizeFromRank: 500001,
    lotSizeToRank: 0,
    level: 'S2',
    sampleSize: '13',
  },
  {
    sampleSize: '80',
    level: 'I',
    lotSizeFromRank: 3201,
    lotSizeToRank: 10000,
    code: 'J',
  },
  {
    level: 'S1',
    code: 'D',
    sampleSize: '8',
    lotSizeFromRank: 500001,
    lotSizeToRank: 0,
  },
  {
    lotSizeFromRank: 16,
    sampleSize: '2',
    code: 'A',
    lotSizeToRank: 25,
    level: 'S2',
  },
  {
    sampleSize: '3',
    lotSizeToRank: 25,
    level: 'S3',
    code: 'B',
    lotSizeFromRank: 16,
  },
  {
    lotSizeFromRank: 500001,
    lotSizeToRank: 0,
    code: 'H',
    sampleSize: '50',
    level: 'S3',
  },
  {
    sampleSize: '2',
    lotSizeToRank: 15,
    level: 'S2',
    code: 'A',
    lotSizeFromRank: 9,
  },
  {
    lotSizeToRank: 3200,
    lotSizeFromRank: 1201,
    sampleSize: '32',
    level: 'S4',
    code: 'G',
  },
  {
    sampleSize: '5',
    code: 'C',
    lotSizeFromRank: 151,
    lotSizeToRank: 280,
    level: 'S2',
  },
  {
    lotSizeFromRank: 16,
    code: 'B',
    level: 'I',
    lotSizeToRank: 25,
    sampleSize: '3',
  },
  {
    code: 'C',
    sampleSize: '5',
    lotSizeFromRank: 10001,
    lotSizeToRank: 35000,
    level: 'S1',
  },
  {
    code: 'E',
    level: 'I',
    lotSizeFromRank: 151,
    sampleSize: '13',
    lotSizeToRank: 280,
  },
  {
    lotSizeFromRank: 35001,
    sampleSize: '13',
    lotSizeToRank: 150000,
    level: 'S2',
    code: 'E',
  },
  {
    sampleSize: '3',
    lotSizeToRank: 50,
    code: 'B',
    lotSizeFromRank: 26,
    level: 'S2',
  },
  {
    sampleSize: '200',
    level: 'III',
    code: 'L',
    lotSizeFromRank: 1201,
    lotSizeToRank: 3200,
  },
  {
    sampleSize: '3',
    lotSizeFromRank: 9,
    lotSizeToRank: 15,
    level: 'II',
    code: 'B',
  },
  {
    code: 'C',
    sampleSize: '5',
    lotSizeToRank: 3200,
    level: 'S1',
    lotSizeFromRank: 1201,
  },
  {
    code: 'L',
    sampleSize: '200',
    level: 'II',
    lotSizeToRank: 10000,
    lotSizeFromRank: 3201,
  },
  {
    lotSizeFromRank: 51,
    sampleSize: '5',
    lotSizeToRank: 90,
    level: 'I',
    code: 'C',
  },
  {
    level: 'II',
    lotSizeFromRank: 91,
    sampleSize: '20',
    code: 'F',
    lotSizeToRank: 150,
  },
  {
    lotSizeToRank: 500,
    sampleSize: '20',
    lotSizeFromRank: 281,
    level: 'I',
    code: 'F',
  },
  {
    lotSizeToRank: 150,
    level: 'III',
    sampleSize: '32',
    code: 'G',
    lotSizeFromRank: 91,
  },
  {
    sampleSize: '80',
    level: 'II',
    lotSizeFromRank: 501,
    lotSizeToRank: 1200,
    code: 'J',
  },
  {
    lotSizeFromRank: 3201,
    sampleSize: '315',
    code: 'M',
    lotSizeToRank: 10000,
    level: 'III',
  },
  {
    lotSizeToRank: 500,
    level: 'S2',
    sampleSize: '5',
    code: 'C',
    lotSizeFromRank: 281,
  },
  {
    sampleSize: '2',
    lotSizeFromRank: 9,
    level: 'I',
    lotSizeToRank: 15,
    code: 'A',
  },
  {
    level: 'S1',
    lotSizeToRank: 500,
    lotSizeFromRank: 281,
    sampleSize: '3',
    code: 'B',
  },
  {
    lotSizeFromRank: 51,
    level: 'S4',
    code: 'C',
    lotSizeToRank: 90,
    sampleSize: '5',
  },
]
